import React from 'react';
import Paper from '@mui/material/Paper';
import MenuItem from '@mui/material/MenuItem';
import MenuList from '@mui/material/MenuList';

import { formatVariableName } from 'src/common/playbook-variables/playbook-variable-utils';

type Props = {
    items: string[],
    command: (props: { id: string }) => void
}

export default function VariablesList({
    items,
    command
}: Props) {
    const selectItem = (index: number) => {
        const item = items[index];

        if (item) {
            command({ id: item });
        }
    };

    const hasItems = items.length > 0;

    return (
        <Paper>
            <MenuList>
                {items.map((item, i) => (
                    <MenuItem key={i} onClick={() => selectItem(i)}>
                        {formatVariableName(item)}
                    </MenuItem>
                ))}

                {!hasItems && <div className="item">No result</div>}
            </MenuList>
        </Paper>
    );
}
